import { call, put } from 'redux-saga/effects';

import {
  setCheckDailyQuizStatusWaiting,
  setDailyQuiz,
  setDailyQuizRetake,
  setDailyQuizRunning,
  setDailyTimeOut,
  setIsLoadingQualDailyQuizStatus,
  setIsLoadingSubmitQualDailyQuiz,
  setIsQualDailyQuizRunning,
  setIsSubmitQualDailyQuizSuccessful,
  setLoadDailyQuizWaiting,
  setNextQualDailyQuizIn,
  setNextQuizIn,
  setProgress,
  setQualDailyQuiz,
  setQualDailyQuizDailyTimeOut,
  setQualDailyQuizProgress,
  setQualDailyQuizRetake,
  setQuestionsDailyQuiz,
  setSubmitDailyQuizSuccess,
  setSubmitDailyQuizWaiting,
} from '../actions/dailyQuizActions';
import Services from '../services';
import history from '../utils/history';

export function* getDailyQuizQuestionsSagas(action) {
  try {
    const rate = action.rate;
    const response = yield call(
      Services.DailyQuizService.getDailyQuizQuestionsService,
      rate,
    );
    yield put(setQuestionsDailyQuiz(response)); // Here we update the reducer state. (We must do this after the API call)
  } catch (exception) {
    // alert(exception);
  }
}

export function* sendAnswerSagas(action) {
  try {
    const answer = action.answer;
    yield call(Services.DailyQuizService.sendDailyQuizAnswerService, answer); // Im just suppousing
  } catch (exception) {
    // alert(exception);
  }
}

export function* getDailyQuizResultsSagas(action) {
  try {
    const id = action.id;
    yield call(Services.DailyQuizService.getDailyQuizResultsService, id); // Im just suppousing
  } catch (exception) {
    // alert(exception);
  }
}

export function* checkDailyQuizStatusSaga() {
  try {
    yield put(setCheckDailyQuizStatusWaiting(true));
    yield put(setDailyQuizRunning(null));

    const response = yield call(Services.DailyQuizService.checkDailyQuizStatus);

    if (response === 'No quiz found for today') {
      throw new Error('No quiz found for today');
    }

    if (response.nextQuizIn !== null && response.nextQuizIn !== undefined) {
      yield put(setNextQuizIn(response.nextQuizIn));
      if (response.nextQuizIn === 0) {
        // If the next quiz is available now, set the progress to 100%
        yield put(setProgress(100));
      } else {
        // Otherwise, calculate the progress based on the hours left until the next quiz
        yield put(setProgress(100 - (Number(response.nextQuizIn) * 100) / 24));
      }
    }

    if (
      response.dailyQuizRunning !== null &&
      response.dailyQuizRunning !== undefined
    ) {
      yield put(setDailyQuizRunning(response.dailyQuizRunning));
    }

    if (response === 'No quiz found for today') {
      yield put(setNextQuizIn(-1));
      yield put(setProgress(0));
    }

    yield put(setCheckDailyQuizStatusWaiting(false));
  } catch {
    yield put(setNextQuizIn(-1));
    yield put(setProgress(0));
    yield put(setCheckDailyQuizStatusWaiting(false));
  }
}

export function* checkQualDailyQuizStatusSaga() {
  try {
    yield put(setIsLoadingQualDailyQuizStatus(true));
    yield put(setIsQualDailyQuizRunning(null));

    const response = yield call(
      Services.DailyQuizService.checkQualDailyQuizStatus,
    );

    if (response.nextQuizIn !== null && response.nextQuizIn !== undefined) {
      yield put(setNextQualDailyQuizIn(response.nextQuizIn));
      if (response.nextQuizIn === 0) {
        yield put(setQualDailyQuizProgress(100));
      } else {
        yield put(
          setQualDailyQuizProgress(
            100 - (Number(response.nextQuizIn) * 100) / 24,
          ),
        );
      }
    }

    if (
      response.dailyQuizRunning !== null &&
      response.dailyQuizRunning !== undefined
    ) {
      yield put(setIsQualDailyQuizRunning(response.dailyQuizRunning));
    }

    if (response === 'No quiz found for today') {
      yield put(setNextQualDailyQuizIn(-1));
      yield put(setQualDailyQuizProgress(0));
    }
  } catch (error) {
    yield put(setNextQualDailyQuizIn(-1));
    yield put(setQualDailyQuizProgress(0));
  } finally {
    yield put(setIsLoadingQualDailyQuizStatus(false));
  }
}

export function* loadDailyQuizSaga(action) {
  try {
    yield put(setLoadDailyQuizWaiting(true));

    const response = yield call(
      Services.DailyQuizService.loadDailyQuiz,
      action.id,
      action.isRetake,
    );

    if (response.quiz) {
      if (action.isRetake) {
        yield put(setDailyQuizRetake(response.quiz));
      } else {
        yield put(setDailyQuiz(response.quiz));
        yield put(setDailyTimeOut(true));
      }
    }

    if (!action.isRetake) {
      const status = yield call(Services.DailyQuizService.checkDailyQuizStatus);

      if (status.nextQuizIn !== null && status.nextQuizIn !== undefined) {
        yield put(setNextQuizIn(status.nextQuizIn));
        if (response.nextQuizIn === 0) {
          yield put(setProgress(100));
        } else {
          yield put(
            setProgress(100 - (Number(response.nextQuizIn) * 100) / 24),
          );
        }
      }

      if (
        status.dailyQuizRunning !== null &&
        status.dailyQuizRunning !== undefined
      ) {
        yield put(setDailyQuizRunning(status.dailyQuizRunning));
      }
    }

    if (response.notAvailable) {
      // history.push('/app/dashboard');
      yield put(setDailyTimeOut(false));
      yield put(setLoadDailyQuizWaiting(false));
    }

    yield put(setLoadDailyQuizWaiting(false));
  } catch {
    history.push('/app/dashboard');
    yield put(setDailyTimeOut(false));
    yield put(setLoadDailyQuizWaiting(false));
  }
}

export function* loadQualDailyQuizSaga(action) {
  try {
    yield put(setIsLoadingQualDailyQuizStatus(true));

    const response = yield call(
      Services.DailyQuizService.loadQualDailyQuiz,
      action.id,
      action.isRetake,
    );

    if (response.quiz) {
      if (action.isRetake) {
        yield put(setQualDailyQuizRetake(response.quiz));
      } else {
        yield put(setQualDailyQuiz(response.quiz));
        yield put(setQualDailyQuizDailyTimeOut(true));
      }
    }

    if (!action.isRetake) {
      const status = yield call(
        Services.DailyQuizService.checkQualDailyQuizStatus,
      );

      if (status.nextQuizIn !== null && status.nextQuizIn !== undefined) {
        yield put(setNextQualDailyQuizIn(status.nextQuizIn));

        if (response.nextQuizIn === 0) {
          yield put(setQualDailyQuizProgress(100));
        } else {
          yield put(
            setQualDailyQuizProgress(
              100 - (Number(response.nextQuizIn) * 100) / 24,
            ),
          );
        }
      }

      if (
        status.dailyQuizRunning !== null &&
        status.dailyQuizRunning !== undefined
      ) {
        yield put(setIsQualDailyQuizRunning(status.dailyQuizRunning));
      }
    }

    if (response.notAvailable) {
      yield put(setQualDailyQuizDailyTimeOut(false));
    }
  } catch (error) {
    history.push('/app/dashboard');
    yield put(setQualDailyQuizDailyTimeOut(false));
  } finally {
    yield put(setIsLoadingQualDailyQuizStatus(false));
  }
}

export function* updateDailyQuizSaga(action) {
  try {
    const response = yield call(
      Services.DailyQuizService.updateDailyQuiz,
      action.dailyQuizId,
      action.dataResultsDetailed,
      action.isRetake,
    );

    if (response.quiz) {
      if (action.isRetake) {
        yield put(setDailyQuizRetake(response.quiz));
      } else {
        const running =
          response.quiz.questions.length -
          JSON.parse(response.quiz.resultsDetailed).length;
        yield put(setDailyQuiz(response.quiz));
        yield put(setDailyQuizRunning(running));
      }
    }
  } catch (err) {}
}

export function* updateQualDailyQuizSaga(action) {
  try {
    const response = yield call(
      Services.DailyQuizService.updateQualDailyQuiz,
      action.qualDailyQuizId,
      action.dataResultsDetailed,
      action.isRetake,
    );

    if (response.quiz) {
      if (action.isRetake) {
        yield put(setQualDailyQuizRetake(response.quiz));
      } else {
        const running =
          response.quiz.questions.length -
          JSON.parse(response.quiz.resultsDetailed).length;

        yield put(setQualDailyQuiz(response.quiz));
        yield put(setIsQualDailyQuizRunning(running));
      }
    }
  } catch (error) {}
}

export function* submitDailyQuizSaga(action) {
  try {
    yield put(setSubmitDailyQuizWaiting(true));

    const response = yield call(
      Services.DailyQuizService.submitDailyQuiz,
      action.dailyQuizId,
      action.dataResultsDetailed,
      action.isRetake,
    );

    if (response.quiz) {
      if (action.isRetake) {
        yield put(setDailyQuizRetake(null));
      } else {
        yield put(setDailyQuiz(response.quiz));
        yield put(setDailyQuizRunning(null));
      }
    }

    yield put(setSubmitDailyQuizWaiting(false));
    yield put(setSubmitDailyQuizSuccess(true));
  } catch (err) {
    yield put(setSubmitDailyQuizWaiting(false));
    yield put(setSubmitDailyQuizSuccess(false));
  }
}

export function* submitQualDailyQuizSaga(action) {
  try {
    yield put(setIsLoadingSubmitQualDailyQuiz(true));

    const response = yield call(
      Services.DailyQuizService.submitQualDailyQuiz,
      action.qualDailyQuizId,
      action.dataResultsDetailed,
      action.isRetake,
    );

    if (response.quiz) {
      if (action.isRetake) {
        yield put(setQualDailyQuizRetake(null));
      } else {
        yield put(setQualDailyQuiz(response.quiz));
        yield put(setIsQualDailyQuizRunning(null));
      }
    }

    yield put(setIsSubmitQualDailyQuizSuccessful(true));
  } catch (error) {
    yield put(setIsSubmitQualDailyQuizSuccessful(false));
  } finally {
    yield put(setIsLoadingSubmitQualDailyQuiz(false));
  }
}
